<template>
  <div class="content">
    <div class="row filter-section">
      <div class="col-md-4">
        <ArtistSelect
          :show-all-units="true"
          :is-filter="true"
          :initial-unit-id="$route.query.unitId ? parseInt($route.query.unitId, 10) : null"
          :initial-member-id="$route.query.artistId ? parseInt($route.query.artistId, 10) : null"
          :includeUnitArtist="true"
          @memberChangeEvent="getArtistInfo"
        />
      </div>
      <div class="col-md-8">
        <div class="row">
          <div class="col-md-3">
            <h4 class="card-title text-left">명언/TMI</h4>
            <div class="row">
              <div class="col-md-12 text-left">
                <el-select class="select-primary" size="large" placeholder="카테고리" v-model="category" @change="getTrivia()">
                  <el-option
                    v-for="option in categoryOptions"
                    class="select-primary"
                    :value="option.value"
                    :label="option.label"
                    :key="option.label"
                  ></el-option>
                </el-select>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <h4 class="card-title text-left">정렬</h4>
            <div class="row">
              <div class="col-md-12 text-left">
                <el-select class="select-primary" size="large" placeholder="멤버선택" v-model="orderBy" @change="getTrivia()">
                  <el-option
                    v-for="option in orderByOptions"
                    class="select-primary"
                    :value="option.value"
                    :label="option.label"
                    :key="option.label"
                  ></el-option>
                </el-select>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <h4 class="card-title text-left">상태</h4>
            <div class="row">
              <div class="col-md-12 text-left">
                <el-select class="select-primary" size="large" placeholder="상태" v-model="isVisible" @change="getTrivia()">
                  <el-option
                    v-for="option in visibleOptions"
                    class="select-primary"
                    :value="option.value"
                    :label="option.label"
                    :key="option.label"
                  ></el-option>
                </el-select>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <h4 class="card-title text-left">범위</h4>
            <div class="row">
              <div class="col-md-12 text-left">
                <el-select class="select-primary" size="large" placeholder="범위" v-model="isHot" @change="getTrivia()">
                  <el-option v-for="option in hotOptions" class="select-primary" :value="option.value" :label="option.label" :key="option.label"></el-option>
                </el-select>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-2">
        <base-input v-model="likeCount" placeholder="좋아유"></base-input>
      </div>
      <div class="col-md-6">
        <SimpleSearch @simpleSearchEvent="setKeyword" />
      </div>
    </div>

    <div class="row">
      <el-table :data="data" :cell-style="{ padding: '0', height: '200px' }">
        <el-table-column :min-width="30" align="center" label="ID">
          <div slot-scope="props">
            {{ props.row.id }}
          </div>
        </el-table-column>
        <el-table-column :min-width="50" align="center" label="유저">
          <div slot-scope="props" @click="onClickUserId(props.row.userId)">
            {{ props.row.userInfo }}
          </div>
        </el-table-column>
        <el-table-column :min-width="50" align="center" label="멤버">
          <div slot-scope="props">
            <el-select v-if="unitId" class="select-primary" size="large" placeholder="범위" v-model="props.row.artistId">
              <el-option v-for="option in members" class="select-primary" :value="option.value" :label="option.label" :key="option.label"></el-option>
            </el-select>
            <div v-else>{{ props.row.unitName }} {{ props.row.memberName }}</div>
          </div>
        </el-table-column>
        <el-table-column :min-width="100" align="center" label="내용">
          <div slot-scope="props">
            <base-input placeholder="설명">
              <textarea class="form-control" rows="50" v-model="props.row.message" />
            </base-input>
          </div>
        </el-table-column>
        <el-table-column :min-width="100" align="center" label="출처">
          <div slot-scope="props">
            <base-input placeholder="설명">
              <textarea class="form-control" rows="50" v-model="props.row.source" />
            </base-input>
          </div>
        </el-table-column>
        <el-table-column :min-width="50" align="center" label="상세 정보">
          <div slot-scope="props">
            {{ props.row.status }}
          </div>
        </el-table-column>
        <el-table-column :min-width="50" align="center" label="댓글보기">
          <div slot-scope="props">
            <base-button @click.native.stop="onClickComments(props.row.id, props.row.unitId)" class="edit btn-minus" type="warning" size="sm" icon>
              <i class="tim-icons icon-book-bookmark" />
            </base-button>
          </div>
        </el-table-column>
        <el-table-column v-if="isVisible === 1" :min-width="30" align="right" label="숨김">
          <div slot-scope="props">
            <base-button @click.native.stop="hideTrivia(props.row)" class="edit btn-minus" type="warning" size="sm" icon>
              <i class="tim-icons icon-minus" />-
            </base-button>
          </div>
        </el-table-column>
        <el-table-column :min-width="30" align="right" label="수정">
          <div slot-scope="props">
            <base-button @click.native.stop="modifyTrivia(props.row)" class="edit btn-minus" type="warning" size="sm" icon>
              <i class="tim-icons" />수정
            </base-button>
          </div>
        </el-table-column>
        <el-table-column v-if="isVisible === 1 && isHot === 1" :min-width="30" align="right" label="알림전송">
          <div slot-scope="props">
            <base-button @click.native="sendNotification(props.row)" class="edit btn-link" type="warning" size="sm" icon>
              <i class="tim-icons icon-send" />
            </base-button>
          </div>
        </el-table-column>
        <el-table-column :min-width="30" align="right" label="인기선정">
          <div slot-scope="props">
            <base-button v-if="props.row.isHot === 0" @click.native="onClickApprove(props.row)" class="edit btn-link" type="warning" size="sm" icon>
              인기
            </base-button>
            <base-button v-if="props.row.isHot === 1" @click.native="onClickRemoveFromHot(props.row)" class="edit btn-link" type="warning" size="sm" icon>
              내림
            </base-button>
          </div>
        </el-table-column>
      </el-table>
    </div>
    <div class="row">
      <base-pagination class="pagination-no-border" v-model="currentPage" :pageCount="totalPages" />
    </div>
    <TriviaContentModal
      :shouldShow="confirmModal.show"
      :messages="confirmModal.messages"
      :onConfirm="onConfirmModal"
      :onCancel="onCancelModal"
    ></TriviaContentModal>
  </div>
</template>

<script>
import ArtistSelect from "@/pages/Components/ArtistSelect.vue";
import { showAPIErrorToast } from "@/util/ErrorUtils";
import { BaseInput, BasePagination } from "@/components/index";
import { Alert } from "@/util/Alert";
import { URLUtils } from "@/util/URLUtils";
import TriviaContentModal from "@/pages/Trivia/TriviaContentModal";
import { Toast } from "@/util/Toast";
import swal from "sweetalert2";
import handlebars from "handlebars";
import SimpleSearch from "@/pages/Components/SimpleSearch.vue";

const CONFIRM_MODE_APPROVAL = "approval"; //스케줄 승인(스케줄 추가 또는 변경됨) + 알림
const CONFIRM_MODE_REJECTION = "rejection"; //반려

export default {
  name: "TriviaContents",
  components: {
    ArtistSelect,
    BaseInput,
    BasePagination,
    TriviaContentModal,
    SimpleSearch,
  },
  async created() {
    if (!_.isEmpty(this.$route.query)) {
      if (this.$route.query.category) {
        this.category = this.$route.query.category;
      }
      if (this.$route.query.contentId) {
        this.contentId = parseInt(this.$route.query.contentId);
      }
    }
  },
  data() {
    return {
      currentPage: 1,
      totalPages: 1,
      likeCount: 0,
      data: [],
      confirmModal: {
        show: false,
        mode: "approval",
        messages: [],
        report: null,
      },
      unitId: null,
      artistId: null,
      contentId: null,
      isHot: null,
      hotOptions: [
        { value: null, label: "전체" },
        { value: 1, label: "인기" },
        { value: 0, label: "비인기" },
      ],
      category: "quotation",
      categoryOptions: [
        { value: null, label: "전체" },
        { value: "quotation", label: "명언" },
        { value: "tmi", label: "TMI" },
      ],
      orderByOptions: [
        { value: 0, label: "기본순" },
        { value: 1, label: "좋아요순" },
        { value: -1, label: "싫어요순" },
      ],
      orderBy: 0,
      isVisible: null,
      visibleOptions: [
        { value: null, label: "전체" },
        { value: 1, label: "표시" },
        { value: 0, label: "숨김" },
      ],
      members: [],
      notification: {
        titleTemplate: "[{{unitName}}] {{content}}",
        messageTemplate: "{{memberName}}의 {{categoryName}} 알고 계셨나요? {{emoji}}",
        title: "[{{unitName}}] {{content}}",
        message: "{{memberName}}의 {{categoryName}} 알고 계셨나요? {{emoji}}",
        memberIds: [],
        action: "openTriviaDetail",
        category: "tmi",
        notificationType: 45,
      },
    };
  },
  watch: {
    unitId: {
      async handler() {
        this.members = [];
        if (this.unitId) {
          await this.getArtistUnits();
          await this.getArtistMembers();
        }
      },
      immediate: true,
    },
    currentPage: {
      handler() {
        this.getTrivia(this.currentPage);
      },
    },
  },
  methods: {
    async setKeyword(param) {
      if (param.keyword !== "") {
        this.keyword = param.keyword;
      } else {
        this.keyword = null;
      }
      await this.getTrivia();
    },
    async getArtistInfo(param) {
      this.unitId = param.unitId;
      this.memberId = param.memberId;
      this.unitName = param.unitName;
      await this.getTrivia();
    },
    async getTrivia(page) {
      const queryParams = {
        unitId: this.unitId || undefined,
        category: this.category || "quotation",
        contentId: this.contentId || undefined,
      };
      if (this.unitId !== null) {
        const path = `/trivia/triviaContents?${URLUtils.objectToQueryString(queryParams)}`;
        if (this.$route.fullPath !== path) {
          try {
            await this.$router.push(path);
          } catch (ex) {}
        }
      }
      const url = this.unitId ? `/trivia/${this.unitId}` : "/trivia";
      return this.$axios
        .get(url, {
          params: {
            keyword: this.keyword,
            memberId: this.memberId,
            category: this.category,
            orderBy: this.orderBy,
            isVisible: this.isVisible,
            isHot: this.isHot,
            contentId: this.contentId,
            likeCount: this.likeCount,
            currentPage: page ? page : 1,
          },
        })
        .then((res) => {
          this.data = res.data.data.data.map((d) => {
            d.userInfo = `${d.nickname}(${d.userId})`;
            d.status = `${d.likeCount}좋아요/${d.commentCount}댓글/${d.pinCount}저장`;
            return d;
          });
          this.totalPages = Number(res.data.data.page);
        });
    },
    async getArtistUnits() {
      return this.$axios.get(`/artistUnit/${this.unitId}`, null).then((res) => {
        const data = res.data.data;
        if (data.isGroup === 1) {
          this.members.push({ label: data.blipName, value: data.artistId });
        }
      });
    },
    async getArtistMembers() {
      return this.$axios.get(`/artistUnit/${this.unitId}/members`, null).then((res) => {
        const data = res.data.data;
        if (data.length > 0) {
          data.forEach((item) => {
            const option = {};
            option.label = item.blipName ? item.blipName : item.name;
            option.value = item.artistId;
            this.members.push(option);
          });
        }
      });
    },
    async hideTrivia(row) {
      if (await Alert.dangerousConfirmCancel("숨김하시겠어요?")) {
        try {
          const params = { id: row.id, isVisible: 0 };

          await this.$axios.delete(`/trivia/${row.unitId}`, { params });
          Toast.success("숨김처리되었습니다");
          await this.getTrivia();
        } catch (err) {
          showAPIErrorToast(err);
        }
      }
    },
    async modifyTrivia(row) {
      if (await Alert.dangerousConfirmCancel("수정하시겠어요?")) {
        try {
          await this.$axios.put(`/trivia/${row.id}`, row);
          Toast.success("수정되었습니다");
          await this.getTrivia();
        } catch (err) {
          showAPIErrorToast(err);
        }
      }
    },
    async removeHotTrivia(row) {
      if (await Alert.dangerousConfirmCancel("인기에서 제거하시겠어요?")) {
        try {
          await this.$axios.delete(`/trivia/${row.unitId}/hot`, { params: { id: row.id } });
          Toast.success("인기에서 제거 + 인기 블랙 되었습니다");
          await this.getTrivia();
        } catch (err) {
          showAPIErrorToast(err);
        }
      }
    },
    async setHotTrivia(message) {
      if (await Alert.dangerousConfirmCancel("인기로 선정하시겠어요?")) {
        const params = this.selectedRow;
        if (message) {
          params.notificationTitle = message.split("\n")[0];
          params.notificationMessage = message.split("\n")[1];
          params.userIds = [this.selectedRow.userId];
        }
        try {
          await this.$axios.post(`/trivia/${this.selectedRow.unitId}/hot`, params);
          Toast.success("인기 선정되었습니다");
          await this.getTrivia();
        } catch (err) {
          showAPIErrorToast(err);
        }
      }
    },
    onClickComments(contentId, unitId) {
      this.$router.push(`/comment/all?namespace=800&unitId=${unitId}&contentId=${contentId}`);
    },
    onClickUserId(userId) {
      this.$router.push(`/user/userDetail?userId=${userId}`);
    },
    onClickApprove(row) {
      this.selectedRow = row;
      const categoryName = this.category === "tmi" ? "TMI" : "명언";
      const postposition = this.category === "tmi" ? "가" : "이";
      const postposition2 = this.category === "tmi" ? "로" : "으로";
      this.showConfirmModal(CONFIRM_MODE_APPROVAL, [
        `[${row.unitName}] 제안해주신 ${categoryName}${postposition} 인기 ${categoryName}${postposition2} 지정되었어요! 😆\n지금 바로 확인해보세요!\n 알림 보내기`,
      ]);
    },
    onClickRemoveFromHot(row) {
      this.removeHotTrivia(row);
    },
    async sendNotification(param) {
      swal
        .fire({
          title: "알림 전송 확인",
          text: `알림을 전송하시겠습니까?`,
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "btn btn-danger btn-fill",
          cancelButtonClass: "btn btn-cancel btn-fill",
          confirmButtonText: "전송",
          cancelButtonText: "취소",
          buttonsStyling: false,
        })
        .then(async (selection) => {
          if (selection.value) {
            try {
              const categoryName = this.category === "tmi" ? "TMI" : "명언";
              const emoji = this.category === "tmi" ? "👀" : "🖋️";
              const triviaId = param.contentId;
              const content = param.message.length > 10 ? `${param.message.substring(0, 10).replace(/\n/g, " ")}...` : param.message.replace(/\n/g, " ");
              const memberName = this.members.filter((option) => option.value === param.artistId)[0].label;
              const titleTemplate = handlebars.compile(this.notification.titleTemplate, { noEscape: true });
              const messageTemplate = handlebars.compile(this.notification.messageTemplate, { noEscape: true });
              this.notification.title = titleTemplate({ unitName: param.unitName, content });
              this.notification.message = messageTemplate({ memberName, categoryName, emoji });
              this.notification.memberIds = param.artistId === param.unitArtistId ? [] : [param.artistId];
              this.notification.triviaId = param.id;
              return this.$axios
                .put(`/artistBoard/${param.unitId}/notification`, {
                  params: { triviaId, ...this.notification },
                })
                .then((res) => {
                  Toast.success("전송완료");
                });
            } catch (err) {
              console.log(err);
              Toast.error("알림 전송 중 에러가 발생하였습니다.");
            }
          }
        });
    },
    showConfirmModal(mode, messages) {
      this.confirmModal.mode = mode;
      this.confirmModal.messages = messages;

      this.confirmModal.show = true;
    },
    async onConfirmModal(message) {
      this.confirmModal.show = false;

      if (this.confirmModal.mode === CONFIRM_MODE_APPROVAL) {
        await this.setHotTrivia(message);
      } else if (this.confirmModal.mode === CONFIRM_MODE_REJECTION) {
        await this.setHotTrivia();
      }
    },
    async onCancelModal() {
      this.confirmModal.show = false;
    },
  },
};
</script>
<style lang="scss">
.table-view {
  margin-left: 0;
  margin-bottom: 60px;
}
.filter-section {
  margin-bottom: 50px;
}
textarea {
  min-height: 150px;
}
</style>
